import { render, staticRenderFns } from "./PurchaseReturn.vue?vue&type=template&id=1dd88e96&scoped=true"
import script from "./PurchaseReturn.vue?vue&type=script&lang=js"
export * from "./PurchaseReturn.vue?vue&type=script&lang=js"
import style0 from "./PurchaseReturn.vue?vue&type=style&index=0&id=1dd88e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd88e96",
  null
  
)

export default component.exports